import { render } from "./MedicAssociationsOptions.vue?vue&type=template&id=dd6369a0"
import script from "./MedicAssociationsOptions.vue?vue&type=script&lang=js"
export * from "./MedicAssociationsOptions.vue?vue&type=script&lang=js"

import "./MedicAssociationsOptions.vue?vue&type=style&index=0&id=dd6369a0&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__